import React from "react";
import { useCountUp } from "../../hooks/useCountUp";

/**
 * Renders an animated number with optional prefix/suffix.
 * Preserves layout/typography — only the inner numeric value animates.
 */
export const Counter = ({
  to,
  prefix = "",
  suffix = "",
  decimals = 0,
  duration = 1400,
  className = "",
}) => {
  const [ref, value] = useCountUp(to, { duration, decimals });
  return (
    <span ref={ref} className={className}>
      {prefix}
      {decimals ? value.toFixed(decimals) : value}
      {suffix}
    </span>
  );
};
